import * as React from 'react'

function SvgClose({ title, titleId, ...props }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 26"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" stroke="#696969" strokeLinecap="round" strokeWidth={2.143}>
        <path d="M4.5 4.978l15 15.435M19.5 4.978l-15 15.435" />
      </g>
    </svg>
  )
}

export default SvgClose
